import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const LouderSound: Site = {
  id: 'loudersound',
  logo: 'svg/loudersound.svg',
  label: 'Louder Sound',
  analyticsName: 'loudersound',
  hostname: 'loudersound.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
